import { observer } from 'mobx-react-lite'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { type JobProgressionViewModel } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionViewModel'
import { match } from '@/utils/pattern-match-util'
import { TaxExtensionProgressionActionsContainer } from '@/features/jobs/details/components/JobProgressionCard/TaxExtensionProgressionActions/TaxExtensionProgressionActionsContainer'
import {
  DraftApprovedOutsourcingActions,
  DraftApprovedRetailActions,
  DraftApprovedReviewActions,
} from '@/features/jobs/details/components/JobProgressionCard/DraftApprovedProgressionActions'

export interface DraftApprovedProgressionActionsContainerProps {
  vm: JobProgressionViewModel
  jobVm: JobDetailsViewModel
  canCompleteJob?: boolean
}

export const DraftApprovedProgressionActionsContainer = observer(
  function DraftApprovedProgressionActionsContainer({
    vm,
    jobVm,
    canCompleteJob,
  }: DraftApprovedProgressionActionsContainerProps) {
    return match(vm.currentProgressionFlow, {
      Outsourcing: () => (
        <DraftApprovedOutsourcingActions
          isAnyExtensionFlowAvailable={vm.isAnyExtensionFlowAvailable}
          canCompleteJob={canCompleteJob}
          pendingActionsText={jobVm.scopeChangesVm.pendingActionsText}
          onCompleteJob={vm.closeJob}
          extensionActions={
            vm.isAnyExtensionFlowAvailable && (
              <TaxExtensionProgressionActionsContainer vm={vm} />
            )
          }
        />
      ),
      Retail: () => (
        <DraftApprovedRetailActions
          isAnyExtensionFlowAvailable={vm.isAnyExtensionFlowAvailable}
          onAuthorizationReceived={vm.answerAuthorizationSigned}
          extensionActions={
            vm.isAnyExtensionFlowAvailable && (
              <TaxExtensionProgressionActionsContainer vm={vm} isSecondary />
            )
          }
        />
      ),
      Essential: () => null,
      None: () => null,
      Preparation: () => null,
      Review: () => (
        <DraftApprovedReviewActions
          onReviewCompleted={vm.viewReturnFiledDocumentCreationModal}
        />
      ),
      PersonalExtension: () => null,
      BusinessExtension: () => null,
      OutsourcingExtension: () => null,
    })
  },
)
